import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import guards from './guards';

Vue.use(VueRouter);

const scrollBehavior = (to, from, savedPosition) => {
  const position = savedPosition || { x: 0, y: 0 };

  return position;
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});

guards.forEach((item) => {
  router.beforeEach(item);
});

export default router;
